import React, { FC } from 'react';

export type LocationsViewMode = 'list' | 'map';

const MAP_MASK_STYLE: React.CSSProperties = {
	WebkitMaskImage: `url('/locations_map_view.svg')`,
	WebkitMaskRepeat: 'no-repeat',
	WebkitMaskSize: 'contain',
	WebkitMaskPosition: 'center',
	maskImage: `url('/locations_map_view.svg')`,
	maskRepeat: 'no-repeat',
	maskSize: 'contain',
	maskPosition: 'center',
};

interface LocationsViewModeToggleProps {
	viewMode: LocationsViewMode;
	onViewModeChange: (mode: LocationsViewMode) => void;
	isSupplier: boolean;
}

const LocationsViewModeToggle: FC<LocationsViewModeToggleProps> = ({
	viewMode,
	onViewModeChange,
	isSupplier,
}) => {
	const isListSelected = viewMode === 'list';
	const isMapSelected = viewMode === 'map';

	const primaryBorderClass = isSupplier ? 'border-supplier' : 'border-buyer';
	const primaryIconTextClass = isSupplier ? 'text-supplier' : 'text-buyer';
	const primaryIconBgClass = isSupplier ? 'bg-supplier' : 'bg-buyer';
	const primaryIconHoverBgClass = isSupplier ? 'group-hover:bg-supplier' : 'group-hover:bg-buyer';
	const primaryIconHoverTextClass = isSupplier
		? 'group-hover:text-supplier'
		: 'group-hover:text-buyer';

	const listButtonClassName = [
		'group flex h-10 w-10 cursor-pointer items-center justify-center border border-solid bg-white',
		'rounded-l-[2px]',
		isListSelected ? ['relative z-[1]', primaryBorderClass].join(' ') : 'border-grey-5',
	].join(' ');

	const mapButtonClassName = [
		'group -ml-px flex h-10 w-10 cursor-pointer items-center justify-center border border-solid bg-white',
		isMapSelected ? ['relative z-[1]', primaryBorderClass].join(' ') : 'border-grey-5',
	].join(' ');

	const listIconClassName = [
		'icons8-font icons8-bulleted-list-2 text-base leading-none',
		isListSelected ? primaryIconTextClass : ['text-grey-8', primaryIconHoverTextClass].join(' '),
	].join(' ');

	const mapIconClassName = [
		'h-[15px] w-4',
		isMapSelected ? primaryIconBgClass : ['bg-grey-8', primaryIconHoverBgClass].join(' '),
	].join(' ');

	return (
		<div className="inline-flex">
			<button
				type="button"
				className={listButtonClassName}
				title="List view"
				aria-pressed={isListSelected}
				onClick={() => onViewModeChange('list')}
			>
				<i className={listIconClassName} />
			</button>
			<button
				type="button"
				className={mapButtonClassName}
				title="Map"
				aria-pressed={isMapSelected}
				onClick={() => onViewModeChange('map')}
			>
				<div className={mapIconClassName} style={MAP_MASK_STYLE} />
			</button>
		</div>
	);
};

export default LocationsViewModeToggle;
